import React, { useState } from "react";
import Slider from "react-slick";
// import "./BookSlider.css";

export default function BookSlider() {
    const [current, setCurrent] = useState(0);

    const slides = [
        {
            id: 1,
            img: "images/calender-icon.png",
            title: "CHOOSE YOUR TYRES",
            desc: "Browse our wide range of tyres for cars, vans, trucks, agricultural machines, and more or let us recommend the perfect fit.",
            number: "01"
        },
        {
            id: 2,
            img: "images/check-icon.png",
            title: "BOOK YOUR SERVICE",
            desc: "Schedule a convenient time and location. Whether at home, work, or on-site, we make it easy to arrange your tyre fitting.",
            number: "02"
        },
        {
            id: 3,
            img: "images/calender-icon.png",
            title: "WE COME TO YOU",
            desc: "Our fully equipped mobile vans arrive on time, ready to fit, replace, or repair your tyres wherever you are in Scotland.",
            number: "03"
        },
        {
            id: 4,
            img: "images/calender-icon.png",
            title: "BACK ON THE ROAD",
            desc: "Enjoy a fast, professional service that keeps you moving with safe, reliable tyres, fitted right the first time.",
            number: "04"
        }
    ];

    const settings = {
        speed: 1000,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        infinite: true,
        centerMode: true,
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: "0",
        autoplay: true,
        autoplaySpeed: 1500,
        pauseOnHover: true,
        swipe: true,
        beforeChange: (_, nextIndex) => setCurrent(nextIndex)
    };

    return (
        <div className="book-slider">
            <Slider {...settings}>
                {slides.map((slide, index) => {
                    let extraClass = "";
                    if (index === (current - 1 + slides.length) % slides.length) {
                        extraClass = "slick-sprev";
                    }
                    if (index === (current + 1) % slides.length) {
                        extraClass = "slick-snext";
                    }
                    return (
                        <div key={slide.id} className={`book-slide ${extraClass}`}>
                            <div className="slide-content">
                                <div className="book-slide-img">
                                    <img src={slide.img} alt="img" />
                                </div>
                                <div className="book-slide-content">
                                    <h3>{slide.title}</h3>
                                    <p>{slide.desc}</p>
                                </div>
                                <h2>{slide.number}</h2>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
}
